import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2026-01-14 17:43:36 +0100 (Wed, 14 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159808 $
//  Purpose   : domain icon
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { Actions, Sel } from 'uix/registries';
import { useSelector } from 'uix/hooks';
import { VIcon } from 'uix/graphics';
// ---Globals
export const DomainIcon = ({ dname, odid })=>{
    let domains = useSelector(Sel.domains);
    dname = dname || domains.odid2name[odid];
    let ddata = domains.data[dname] ?? {};
    let iconfig = useSelector(Sel.iconfig);
    let colorizeDomains = useSelector((root)=>root.ui.byId['Global/colorizeDomains']?.value);
    let color = colorizeDomains ? ddata.color : undefined;
    return /*#__PURE__*/ _jsx(VIcon, {
        name: `domain_${iconfig.itypes.byId[10][ddata.type]}`,
        style: {
            color
        }
    });
//~ return <VIcon name="warehouse" style={{color}} />
};
